import React from 'react';

// Components
import * as S from './Styled';
import Menu from '../Menu';
import Icon from '../Icon';
import Container from '../Container';
import LangSwitcher from '../LangSwitcher';
import { useTranslation } from 'react-i18next';
import { replaceStr } from '../../utils';
import Placeholder from '../Placeholder';
import { useVariables } from '../../context/variables';

const Footer = () => {
  const { t } = useTranslation();
  const { theme, phone, email, footer_menu, social_icons } = {
    ...useVariables(),
  };
  const logo = theme?.logo;
  const year = new Date().getFullYear();
  const registryUrl =
    'https://www.dls.gov.ua/%d1%80%d0%b5%d1%94%d1%81%d1%82%d1%80-%d1%81%d1%83%d0%b1%d1%94%d0%ba%d1%82%d1%96%d0%b2-%d0%b3%d0%be%d1%81%d0%bf%d0%be%d0%b4%d0%b0%d1%80%d1%8e%d0%b2%d0%b0%d0%bd%d0%bd%d1%8f-%d1%8f%d0%ba%d1%96/';

  return (
    <S.Footer>
      <Container>
        <S.Content>
          <S.LeftColumn>
            <S.MenuOuter>
              <Menu menuKeys={footer_menu} />
            </S.MenuOuter>
            <S.Info>
              <S.Contacts>
                <S.ContactItem>
                  {phone?.map((num, i) => (
                    <React.Fragment key={'p-' + i}>
                      <S.Phone href={`tel:${replaceStr(num, /\s+/g)}`}>
                        {num}
                      </S.Phone>
                      <br />
                    </React.Fragment>
                  ))}
                </S.ContactItem>
                <S.ContactItem>
                  {email?.map((mail, i) => (
                    <React.Fragment key={'m`-' + i}>
                      <S.Email email={mail}>{mail}</S.Email>
                      <br />
                    </React.Fragment>
                  ))}
                </S.ContactItem>
              </S.Contacts>
              {social_icons ? (
                <S.Social>
                  {social_icons.map(icon => (
                    <S.SocialItem
                      href={icon.href}
                      target={icon.target}
                      key={icon.name}
                    >
                      <Icon name={icon.name} style={icon.style} />
                    </S.SocialItem>
                  ))}
                </S.Social>
              ) : null}
            </S.Info>
            <S.MobileLegalityLink
              href={registryUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/assets/svg/legality.svg"
                alt="Реєстр аптек Держлікслужби"
              />
            </S.MobileLegalityLink>
          </S.LeftColumn>
          <S.RightColumn>
            <S.TopContent>
              {logo ? (
                <S.Logo to="/">
                  <img
                    src={`/assets/svg/logo/${logo}.svg`}
                    alt={logo}
                    width="90"
                    height="48"
                  />
                </S.Logo>
                ) : (
                  <Placeholder style={{ width: 101 }} />
                )}
                <S.LegalityLink
                  href={registryUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/svg/legality.svg"
                    alt="Реєстр аптек Держлікслужби"
                  />
                </S.LegalityLink>
              <LangSwitcher />
            </S.TopContent>
            <S.Copyright>
              © {year}
              {`. ${t('labels.all_rights_reserved')}`}
            </S.Copyright>
          </S.RightColumn>
        </S.Content>
      </Container>
    </S.Footer>
  );
};

export default Footer;
